import type { ComponentProps } from 'react';
import { Button } from './Button';
import { useDialogClose } from './deferred-close';

/**
 * A footer button that closes the layer around it with its exit animation (Cancel, Close, OK). Same props as `Button`;
 * an `onClick` of its own runs first. The layer's `onClose` still runs, once the exit is over.
 */
export function DialogClose({ onClick, ...props }: ComponentProps<typeof Button>) {
  const close = useDialogClose();
  return (
    <Button
      {...props}
      onClick={(e) => {
        onClick?.(e);
        if (!e.defaultPrevented) close();
      }}
    />
  );
}
